import TreeAnimation from '@/assets/images/christmas/animated-tree.gif'
import { Button } from '@/components/ui/button'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'

export const ChristmasPromotionButton = () => {
  const handleOpenDialog = () =>
    openDialog({
      type: DIALOG_TYPE.CHRISTMAS_PROMOTION,
    })

  return (
    <Button
      onClick={handleOpenDialog}
      variant="destructive"
      className="transition-color group relative border-[1.5px] border-[#D9A473] duration-500 hover:bg-[#33662F]"
    >
      <p className="origin-left transition-transform duration-500 group-hover:-translate-y-6 group-hover:-rotate-[15deg]">
        Christmas Offer
      </p>
      <p className="absolute bottom-2 left-4 top-2 origin-left translate-y-6 rotate-[15deg] transition-transform duration-500 group-hover:translate-y-0 group-hover:rotate-0">
        Claim Your Gift!
      </p>
      <img
        src={TreeAnimation}
        alt="Christmas Tree Animation"
        className="ml-0.5 h-9 w-9"
      />
    </Button>
  )
}
